"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const images_1 = require("../../lib/images");
const with_error_boundary_1 = require("../ErrorFallback/with-error-boundary");
const profile_image_styles_1 = require("./profile-image.styles");
const constants_1 = require("../../lib/constants");
const image_component_1 = require("@kyruus/image-component");
const ProfileImage = ({ provider, isCircle }) => {
    const [landscape, setLandscape] = (0, react_1.useState)(false);
    const { config } = (0, image_component_1.useImageService)();
    const onImgLoad = (0, react_1.useCallback)((image) => {
        if (image !== null &&
            image.currentTarget.naturalWidth !== null &&
            image.currentTarget.naturalHeight !== null) {
            setLandscape(image.currentTarget.naturalWidth > image.currentTarget.naturalHeight);
        }
    }, []);
    return (react_1.default.createElement(profile_image_styles_1.ProviderImgWrapper, { isCircle: isCircle, imageEnhancementEnabled: config.enableEnhancement || false },
        react_1.default.createElement(profile_image_styles_1.ProviderImg, { altText: provider.name.full, src: (0, images_1.getProviderImageUrl)(provider), width: constants_1.PROFILE_IMAGE_SIZE, height: constants_1.PROFILE_IMAGE_SIZE, itemProp: "image", onLoad: onImgLoad, isCircle: isCircle, isLandscape: landscape, imageEnhancementEnabled: config.enableEnhancement || false })));
};
ProfileImage.displayName = 'ProfileImage';
exports.default = (0, with_error_boundary_1.withErrorBoundary)(ProfileImage);
//# sourceMappingURL=profile-image.js.map